import _ from 'underscore';
import { AlertLevel, IAlertLevel } from './types';

/**
 * As design required, legacy error alert will be shown as warning alert,
 * legacy info alert will be shown as confirmation alert.
 */
const levelMapping: Record<AlertLevel, IAlertLevel> = {
  Error: 'Warning',
  Warning: 'Warning',
  Confirmation: 'Confirmation',
  Info: 'Confirmation',
};

export const mapAlertLevel = <T extends { level?: AlertLevel }>(alert: T): T & { level: IAlertLevel } => _.extend(alert, { level: levelMapping[alert.level || 'Confirmation'] });

export const getUniqueAlertId = (): string => _.uniqueId('floating-banner-');
